import { useEffect, useState } from "react";
import { ProgramType } from "data/programData";
import useFetch from "./useFetch";
import { setDataWithEditorKeyAndTranslationVersion } from "./useGetBlankTaskData";
import useGetBlankMeditationRecordData from "./useGetBlankMeditationRecordData";
import { getLastShownIndex } from "logic/logics";

export default function useGetMeditationRecordData({
  mrk,
  isFirst,
  enabled = true,
}: {
  mrk?: string;
  isFirst?: boolean;
  enabled?: boolean;
}) {
  const [data, setData] = useState<ProgramType>();
  const [isFetching, setIsFetching] = useState<boolean>(false);

  const blankData = useGetBlankMeditationRecordData({
    mrk: mrk,
    isFirst: isFirst,
    enabled: enabled,
  });

  const [fetchedData, getData] = useFetch({
    url: "/meditation-record/data/load",
    params: { mrk: mrk },
  });

  useEffect(() => {
    if (enabled && mrk && isFirst !== undefined) {
      setIsFetching(true);
      getData();
    }
  }, [mrk, enabled, isFirst]);

  useEffect(() => {
    if (fetchedData && blankData) {
      const totalData = (fetchedData?.result || {}).data;
      if (
        totalData &&
        totalData.content.length > 0 &&
        !(getLastShownIndex(totalData.content) === 0)
      ) {
        setData(setDataWithEditorKeyAndTranslationVersion(totalData));
      } else {
        setData(blankData);
      }
      setIsFetching(false);
    }
  }, [fetchedData, blankData]);

  useEffect(() => {
    if (!fetchedData && blankData) {
      setData(blankData);
    }
  }, [blankData, fetchedData]);

  useEffect(() => {
    if (data) {
      setIsFetching(false);
    }
  }, [data]);

  return { data, refetch: getData, isFetching };
}
